/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerClassStudentsFilterViewModel } from "../types/BannerClassStudentsFilterViewModel.ts";

export const bannerClassStudentsFilterViewModelSchema = z.object({
  filter: z
    .string()
    .describe("Texto para filtrar por descrição ou código da turma. Opcional.")
    .nullish(),
  brandIds: z
    .array(z.number().int())
    .describe(
      "IDs de marca para restringir o resultado. Informe o parâmetro uma ou mais vezes (ex: ?brandIds=1&brandIds=2). Nulo retorna turmas de todas as marcas. Opcional.",
    )
    .nullish(),
  activeOnly: z.optional(
    z
      .boolean()
      .describe(
        "Quando true (padrão), retorna apenas turmas ativas e com data início ≤ hoje ≤ data fim.",
      ),
  ),
  page: z.optional(
    z.number().int().describe("Número da página (base 1). Padrão: 1."),
  ),
  pageSize: z.optional(
    z.number().int().describe("Quantidade de itens por página. Padrão: 20."),
  ),
}) as unknown as ToZod<BannerClassStudentsFilterViewModel>;
